var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-drawer",
    {
      attrs: {
        title: _vm.modalConfig.title,
        visible: _vm.modalConfig.visible,
        width: _vm.modalConfig.width || "80%",
        destroyOnClose: true,
        footer: null,
        maskClosable: false,
        bodyStyle: { padding: "0", height: "94vh" },
      },
      on: { close: _vm.close },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }